<template>
  <Dialog :show.sync="visible" width="400px" title="加窗">
    <template v-slot:body>
      <div class="dialog-body">
        <el-form :model="formData" size="small" label-width="auto">
          <el-form-item label="窗类型" class="form-item">
            <el-select v-model="formData.windowType" placeholder="请选择" size="small">
              <el-option v-for="item in windowTypeList" :key="item.value" :label="item.label" :value="item.value"/>
            </el-select>
          </el-form-item>
        </el-form>
      </div>
    </template>
    <div slot="footer" class="dialog-footer">
      <el-button size="small" @click="visible = false">{{ $t('cancel_k') }}</el-button>
      <el-button size="small" type="primary" @click="onSave">{{ $t('confirm_k') }}</el-button>
    </div>
  </Dialog>
</template>
<script>

export default {
  inject: {
    changeWindowing: {
      default: () => {
        return () => {};
      }
    }
  },
  data() {
    return {
      visible: false,
      formData: {
        windowType: 0
      },
      windowTypeList: [
        {
          label: '无',
          value: 0
        },
        {
          label: '汉宁',
          value: 1
        },
        {
          label: '汉明',
          value: 2
        }
      ]
    }
  },
  methods: {
    onSave() {
      // 直接调用父组件注入的函数
      this.changeWindowing(this.formData.windowType)
      this.visible = false
    },
    open(selectGroup, unit) {
      this.visible = true
      this.codeUnit = unit
      this.selectGroup = selectGroup
    },
  }
}
</script>
